import React from "react";
import { Link } from "react-router-dom";

function Navbar2() {
  return (
    <nav className="navbar navbar-expand-lg sticky-top">
      <div className="container-fluid">
      <Link className="navbar-brand" to="/">
        <img src="./s3/ads_navbar_brand.svg"
          alt="ADS Sports Complex. Absolute Determination and Sacrifice"
          height="95"
        />
      </Link>
       <Link className="navbar-brand" to="/Titansacademy">
        <img src="./s3/titans_logo_white.svg"
          alt="ADS Titans Basketball"
          height="80"
        />
      </Link>
      {/* <li className="nav-item nav-link">
        <Link className="btn btn-outline-light" to="/ReserveCourt">RESERVE A COURT</Link>
      </li> */}
        {/* <Link className="navbar-brand text-white fw-bold" to="/">ADS SPORTS COMPLEX</Link> */}
        <button className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav ms-auto">
            {/* <li className="nav-item">
              <a className="nav-link " aria-current="page" href="#">Home</a>
            </li> */}
             <li className="nav-item dropdown hover-dropdown">
              <a className="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                SPORTS &amp; CAMPS
              </a>
              <ul className="dropdown-menu">
                <li className="nav-item dropdown volleyball-dropdown">
                  <Link
                    className="nav-link dropdown-toggle text-dark "
                    to="/Volleyball"
                    id="volleyballDropdown"
                  >
                    Volleyball
                  </Link>
                <ul className="dropdown-menu" aria-labelledby="volleyballDropdown">
                    <Link className="nav-link text-dark" to="/VolleyballCamps2">
                      Volleyball Clinics &amp; Camps
                    </Link>
                  <li><hr class="dropdown-divider" /></li>
                  <li>
                    <Link className="nav-link text-dark" to="/VolleyballTryouts">
                      Volleyball Club Tryouts
                    </Link>
                    <li><hr class="dropdown-divider" /></li>
                  </li>
                  <div className="nav-title">
                    2025-26 Club Rosters
                  </div>
                  <li>
                    <Link className="nav-link text-dark" to="/ElevenElite">
                      11 Elite
                    </Link>
                  </li>
                  <li>
                    <Link className="nav-link text-dark" to="/FifteenPremier">
                      15 Premier
                    </Link>
                  </li>
                  <li>
                    <Link className="nav-link text-dark" to="/SixteenElite">
                      16 Elite
                    </Link>
                  </li>
                  <li><hr class="dropdown-divider" /></li>
                    <Link className="nav-link text-dark" to="/VolleyballCoaches">
                      Volleyball Coaches
                    </Link>
                </ul>
              </li>
                {/* <li className="nav-item">
                  <Link className="nav-link text-dark" to="/VolleyballCamps2">Volleyball Camps and Programs</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-dark" to="/VolleyballTryouts">Volleyball Club Tryouts</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-dark" to="/ClinicsOpenGym">Volleyball Clinics &amp; Open Gym</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-dark" to="/VolleyballCoaches">Volleyball Coaches</Link>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link text-dark" to="/Basketball">Basketball</Link>
                </li>
                {/* <li className="nav-item">
                  <Link className="nav-link text-dark" to="/BasketballCamps">Basketball Camps</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-dark" to="/BasketballRates">Basketball Rates</Link>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link text-dark" to="/Titansacademy">ADS Titans Academy</Link>
                </li>
                {/* <li className="nav-item">
                  <Link className="nav-link text-dark" to="/Picklball">Pickleball</Link>
                </li> */}
              </ul>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link" to="/VolleyballCamps2">Volleyball Camps</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/VolleyballTryouts">Volleyball Club Tryouts</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/BasketballCamps">Basketball Camps</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/BasketballRates">Basketball Rates</Link>
            </li>
              <li className="nav-item">
              <Link className="nav-link" to="/EventCalendar">Event Calendar</Link>
            </li> 
            <li className="nav-item">
              <Link className="nav-link" to="/CourtRentals">Court Rentals</Link>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link" to="/Leadership">Leadership</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Foundation">Timothy Porter Foundation</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Complex">Complex Showcase</Link>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link btn btn-advertise" to="/Advertise">
              <span>
                <img src="/s3/advertise.svg"
                className="text-primary"
                width={25}
                alt=""
                />   
              </span>
                &nbsp;Advertise with Us
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
    );
}

export default Navbar2;
